import { useEffect, useMemo, useState } from "react"
import { updateIndicatorsProps } from "../../../services/indicator.api";
import { IndicatorProofofPayments } from "./IndicatorProofofPayments";
import { PayedUpload } from "../../../../../types/Indicators.type";

type DocumentIndicatorUploadProps = {
  indicatorId: string;
  currentPath: PayedUpload[];
}

export function IndicatorDocumentsRow(props: DocumentIndicatorUploadProps) {
  const pathToUpload = useMemo(() => `indicators/${props.indicatorId}`, [props.indicatorId])
  const [files, setFiles] = useState<PayedUpload[] | []>([]);

  useEffect(() => {
    if (props.currentPath.length > 0 && props.currentPath[0].cpfFromIndicated) {
      setFiles(props.currentPath);
    }
  }, [props.currentPath])

  const saveIndicatorUpload = async (payedUpload) => {
    const payedUploadArray = Array.isArray(payedUpload) ? payedUpload : [payedUpload];
    await updateIndicatorsProps(props.indicatorId, {
      payedUpload: payedUploadArray,
    })
  }

  return (
    <div className="col-span-3 p-4 dark:text-black rounded-md">
      <h2 className="text-2xl font-semibold mb-4">Comprovantes de Pagamento do Indicador</h2>
      <div className="flex flex-col bg-gray/40 rounded-lg items-stretch">
        <div className={"flex flex-col space-y-2 p-5 my-0 rounded"}>
          <IndicatorProofofPayments
            onChange={saveIndicatorUpload}
            pathToUpload={pathToUpload}
            currentPath={files}
          />
        </div>
      </div>
    </div>
  );
}